import '@theme/assets/styles/legacy.scss';
import '@theme/assets/styles/main.scss';

import { home } from '@theme/assets/scripts/utils.js';

import { createTimeline, utils } from 'animejs';
import { initHeroRibbons } from './home-ribbons.js';
import ribbonData from './home-ribbons.json';
import { initHomeRocket } from './home-rocket.js';

/*
 * Initialise Scripts
 */
function init() {
    if (home()) {
        initHero();
        initHomeRocket(document.querySelector('.home-conference-panel'));
    }

    window.addEventListener('load', function () {
        initGallery();
    });
}

init();

/*
 * Hero Effects
 */

function initHero() {
    const hero = document.querySelector('.home-hero');

    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const ribbons = hero.querySelector('svg.home-hero__ribbons');
    initHeroRibbons(ribbons, ribbonData);
    const eyebrow = hero.querySelector('.home-hero__eyebrow');
    const title = hero.querySelector('h1');
    const date = hero.querySelector('.home-hero__date');
    const cta = hero.querySelector('.button');

    if (!eyebrow || !title || !date) {
        return;
    }

    const animatedElements = [eyebrow, title, date, cta].filter(Boolean);

    utils.set(eyebrow, { opacity: 0, translateY: -18 });
    utils.set(title, { opacity: 0, translateY: 38 });
    utils.set(date, { opacity: 0, translateY: 24 });

    if (cta) {
        utils.set(cta, { opacity: 0, translateY: 24 });
    }

    const timeline = createTimeline({
        defaults: { ease: 'out(3)' },
        onComplete: function () {
            animatedElements.forEach((element) => element.style.removeProperty('transform'));
        }
    });

    timeline.add(eyebrow, { opacity: 1, translateY: 0, duration: 650 }, 180);
    timeline.add(title, { opacity: 1, translateY: 0, duration: 900 }, 320);
    timeline.add(date, { opacity: 1, translateY: 0, duration: 650 }, 720);

    if (cta) {
        timeline.add(cta, { opacity: 1, translateY: 0, duration: 600 }, 880);
    }
}

/*
 * Gallery Block
 */

function initGallery() {
    const gallery = document.querySelector('.gallery');

    if (gallery) {
        const lightbox = gallery.querySelector('.gallery-lightbox');
        const closeButton = lightbox.querySelector('.lightbox-close');

        const images = gallery.querySelectorAll('.gallery-items .image');

        const swiperEl = document.querySelector('swiper-container');
        const thumbsEl = document.querySelector('swiper-container.thumbs');

        const thumbsParams = {
            slidesPerView: 'auto',
            spaceBetween: 16
        };

        Object.assign(thumbsEl, thumbsParams);

        const swiperParams = {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 30,
            navigation: true,
            autoHeight: true,
            hashNavigation: {
                watchState: true
            },
            thumbs: {
                swiper: thumbsEl ? thumbsEl.swiper : null
            }
        };

        Object.assign(swiperEl, swiperParams);

        const swiper = swiperEl.initialize();

        images.forEach((image) => {
            image.addEventListener('click', () => {
                openLightbox(image, lightbox);
            });
        });

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                closeLightbox(lightbox);
            });
        }
    }
}

function openLightbox(image, lightbox) {
    const { target } = image.dataset;

    target && (location.hash = target);
    lightbox && (lightbox.style.display = 'flex');
}

function closeLightbox(lightbox) {
    lightbox && (lightbox.style.display = 'none');
}
